module.exports = {
          srcSet: "/_next/static/images/hirehac-logo-short-dark-500-13cc87e52284e1886e4107c863a147e9.webp"+" 500w",
          images:[ {path: "/_next/static/images/hirehac-logo-short-dark-500-13cc87e52284e1886e4107c863a147e9.webp",width: 500,height: 406}],
          src: "/_next/static/images/hirehac-logo-short-dark-500-13cc87e52284e1886e4107c863a147e9.webp",
          toString:function(){return "/_next/static/images/hirehac-logo-short-dark-500-13cc87e52284e1886e4107c863a147e9.webp"},
          
          width: 500,
          height: 406
        }